import { render, staticRenderFns } from "./NoGoalAlert.vue?vue&type=template&id=67ec80b8"
import script from "./NoGoalAlert.vue?vue&type=script&lang=js"
export * from "./NoGoalAlert.vue?vue&type=script&lang=js"
import style0 from "./NoGoalAlert.vue?vue&type=style&index=0&id=67ec80b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports